import { useEffect } from "react";
import { Box, HStack, VStack } from "../../components/utils";
import BCHeader from "../../shared/BCHeader";
import { useQuickEsopExerciseTransactionStore } from "../../store/useQuickTransactionStore";
import { useAuthStore } from "../../store";
import { useGetOnGoingTransaction } from "../../queries/transactionRound";
import TransactionPreviewPage from "./TransactionPreviewPage";
import QuickAddEsopExercise from "./QuickAddEsopExercise";

function TransactionEsopExerciseTemplate() {
  const { state: template, setState: setTemplate } =
    useQuickEsopExerciseTransactionStore();
  const stepNo = template.stepNo;
  const companyId = useAuthStore.getState().companyId || "";
  const { refetch, data: onGoingTransaction } =
    useGetOnGoingTransaction(companyId);
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (onGoingTransaction) setTemplate(onGoingTransaction);
    else {
      setTemplate({ stepNo: 1, transactionType: "exercise", companyId });
    }
  }, [onGoingTransaction]);

  return (
    <div className="min-h-full">
      <BCHeader
        className="items-baseline mb-2"
        bcTitle="Transaction Dashboard"
        bcSubTitle="Add ESOP Exercises"
      />
      {template.stepNo !== 2 ? <QuickAddEsopExercise /> : null}
      {template.stepNo === 2 ? <TransactionPreviewPage /> : null}
    </div>
  );
}

export default TransactionEsopExerciseTemplate;
